module.exports = __webpack_public_path__ + "img/3.81e0f913.webp";